__turbopack_context__.v({
  "batting-stats": "Leaderboard-module-scss-module__-iqhja__batting-stats",
  "catching-fielder-wrapper": "Leaderboard-module-scss-module__-iqhja__catching-fielder-wrapper",
  "container-wrapper": "Leaderboard-module-scss-module__-iqhja__container-wrapper",
  "custom-table": "Leaderboard-module-scss-module__-iqhja__custom-table",
  "data-cell": "Leaderboard-module-scss-module__-iqhja__data-cell",
  "fielding-stats": "Leaderboard-module-scss-module__-iqhja__fielding-stats",
  "generic-widget-wrapper": "Leaderboard-module-scss-module__-iqhja__generic-widget-wrapper",
  "header": "Leaderboard-module-scss-module__-iqhja__header",
  "header-cell": "Leaderboard-module-scss-module__-iqhja__header-cell",
  "leaderboard-mobile-wrapper": "Leaderboard-module-scss-module__-iqhja__leaderboard-mobile-wrapper",
  "leaderboard-wrapper": "Leaderboard-module-scss-module__-iqhja__leaderboard-wrapper",
  "playerName": "Leaderboard-module-scss-module__-iqhja__playerName",
  "playerStyleSpan": "Leaderboard-module-scss-module__-iqhja__playerStyleSpan",
  "pre-tournament": "Leaderboard-module-scss-module__-iqhja__pre-tournament",
  "row-batting-wrapper": "Leaderboard-module-scss-module__-iqhja__row-batting-wrapper",
  "row-batting-wrapper-last": "Leaderboard-module-scss-module__-iqhja__row-batting-wrapper-last",
  "table-body-custom": "Leaderboard-module-scss-module__-iqhja__table-body-custom",
  "table-head": "Leaderboard-module-scss-module__-iqhja__table-head",
  "table-row": "Leaderboard-module-scss-module__-iqhja__table-row",
  "table-wrapper-scroll": "Leaderboard-module-scss-module__-iqhja__table-wrapper-scroll",
  "team-div": "Leaderboard-module-scss-module__-iqhja__team-div",
  "team-logo": "Leaderboard-module-scss-module__-iqhja__team-logo",
  "wicket-keeping-wrapper": "Leaderboard-module-scss-module__-iqhja__wicket-keeping-wrapper",
});
